import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import translationEN from "./translationEN.json";
import translationBG from "./translationBG.json";

const resources = {
    en: { translation: translationEN },
    bg: { translation: translationBG },
};

/*
    FIXED LOGIC:
    1. Try to get saved language from localStorage.
    2. If none exists → use default language "bg".
*/
const savedLang = localStorage.getItem("i18nextLng");
const initialLang = savedLang || "bg";

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources,
        lng: initialLang,         // <— THIS ensures we don't reset to bg on every load
        fallbackLng: "bg",        // <— Only used when translation missing
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ["localStorage", "navigator"],
            caches: ["localStorage"], // <— VERY important!
        },
    });

export default i18n;


//import i18n from "i18next";
//import { initReactI18next } from "react-i18next";
//import LanguageDetector from "i18next-browser-languagedetector";
//import translationEN from "./translationEN.json";
//import translationBG from "./translationBG.json";

//// --- Define translation resources ---
//const resources = {
//    bg: { translation: translationBG },
//    en: { translation: translationEN },
//};

//// --- Custom detector to read ASP.NET Core cookie ---
//const AspNetCoreCultureDetector = {
//    name: "aspnetcoreCookie",
//    lookup() {
//        try {
//            const match = document.cookie.match(/\.AspNetCore\.Culture=([^;]+)/);
//            if (match) {
//                // Cookie format: c=bg|uic=bg
//                const value = decodeURIComponent(match[1]);
//                const parts = value.split("|");
//                for (let part of parts) {
//                    if (part.startsWith("c=")) return part.substring(2);
//                }
//            }
//        } catch (err) {
//            console.warn("Culture cookie lookup failed:", err);
//        }
//        return null;
//    },
//};

//// --- Register custom detector BEFORE init ---
//const languageDetector = new LanguageDetector();
//languageDetector.addDetector(AspNetCoreCultureDetector);

//// --- Initialize i18next ---
//i18n
//    .use(languageDetector)
//    .use(initReactI18next)
//    .init({
//        resources,
//        lng: 'bg', // ✅ Default language is Bulgarian
//        fallbackLng: 'bg', // ✅ Fallback is also Bulgarian
//        debug: true,
//        detection: {
//            order: ["aspnetcoreCookie", "querystring", "cookie", "localStorage", "navigator"],
//            caches: ["cookie", "localStorage"], // persist user language
//            lookupQuerystring: "lng",
//            lookupCookie: "i18next",
//            lookupLocalStorage: "i18nextLng",
//        },
//        interpolation: {
//            escapeValue: false, // React already escapes
//        },
//    });

//// --- Keep ASP.NET cookie in sync when language changes ---
//i18n.on("languageChanged", (lng) => {
//    // Set .AspNetCore.Culture cookie format: c=bg|uic=bg
//    document.cookie = `.AspNetCore.Culture=c=${lng}|uic=${lng}; path=/; max-age=31536000`;
//    document.cookie = `i18next=${lng}; path=/; max-age=31536000`;
//});

//export default i18n;



//import i18n from "i18next";
//import { initReactI18next } from "react-i18next";
//import Backend from "i18next-http-backend";
//import LanguageDetector from "i18next-browser-languagedetector";
//import translationEN from "./translationEN.json";
//import translationBG from "./translationBG.json";

////var lang = navigator.language;
//const resources = {
//    bg: {
//        translation: translationBG
//    },
//    en: {
//        translation: translationEN
//    }    
//};

//i18n
//    //.use(Backend)
//    .use(LanguageDetector)
//    .use(initReactI18next)
//    .init({
//        resources,
//        detection: {
//            order: ['querystring', 'cookie', 'localStorage', 'navigator'],
//            caches: ['cookie'],
//            lookupQuerystring: 'lng',
//            lookupCookie: 'i18next',
//            lookupLocalStorage: 'i18nextLng',
//        },
//        fallbackLng: "bg", // Fallback to Bulgarian if a key is missing
//        lng: 'bg', // Default language
//        debug: true, // Enable debug mode
//        interpolation: {
//            escapeValue: false,
//        },
//        //backend: {
//        //    loadPath: 'https://localhost:44303/' + lang
//        //}, // your backend options.
//        //backend: {
//        //    loadPath: "/locales/{{lng}}/{{ns}}.json", // Ensure this matches your file structure
//        //},
//    });

//export default i18n;


//import i18n from "i18next";
//import { initReactI18next } from "react-i18next";
////import Backend from "i18next-http-backend";
//import LanguageDetector from "i18next-browser-languagedetector";

//i18n
//    //.use(Backend) // Load translations from the backend
//    .use(LanguageDetector) // Detect user language
//    .use(initReactI18next) // Pass i18n instance to react-i18next
//    .init({
//        fallbackLng: "bg", // Fallback language (Bulgarian)
//        debug: process.env.NODE_ENV === "development", // Enable debug mode in development
//        interpolation: {
//            escapeValue: false, // React already escapes values
//        },
//        //backend: {
//        //    loadPath: "/locales/{{lng}}/{{ns}}.json", // Path to load translations from
//        //},
//    });

//export default i18n;


//import i18n from 'i18next';
//import { initReactI18next } from 'react-i18next';
//import LanguageDetector from 'i18next-browser-languagedetector';

//import translationEN from './locales/en.json';
//import translationBG from './locales/bg.json';

//const resources = {
//    en: {
//        translation: translationEN
//    },
//    bg: {
//        translation: translationBG
//    }
//};

//i18n
//    .use(LanguageDetector) // Detect language from browser or query param
//    .use(initReactI18next)
//    .init({
//        resources,
//        fallbackLng: 'bg', // Default language
//        detection: {
//            order: ['querystring', 'cookie', 'localStorage', 'navigator'],
//            caches: ['cookie']
//        },
//        interpolation: {
//            escapeValue: false // React already protects from XSS
//        }
//    });

//export default i18n;
